<!--升级订单-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container recharge-manage">
      <div v-if="activeIndex === 0">
        <el-form label-width="130px">
          <el-row :gutter="20">
            <el-col :lg="8" :md="8" :xl="8">
              <el-form-item :label="$t('miMember.memberNo')" size="mini">
                <el-input v-model.trim="memberNo" :class="{ 'disabled_remove_css': memberNoDisabled}"
                          :placeholder="$t('')" :readonly="memberNoDisabled" clearable @blur="getAgentno()"/>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12" :xl="6">
              <p :class="{ 'account_name_css': account_name_show}"
                 style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ listQuery.accountName }}</p>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      下一步-->
          <el-button :disabled="oneNextIf" :loading="btnloading" icon="el-icon-right" size="mini" type="success"
                     @click="buttonnext">{{ $t('button.next') }}
          </el-button>
          <!--      取消-->
          <el-button :loading="btnloading" icon="el-icon-close" size="mini" type="danger" @click="buttoncancel">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </div>
      <div v-if="activeIndex === 1">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <el-form :model="listQuery1" label-width="130px">
          <!--        收货人姓名-->
          <el-form-item :label="$t('PoOrder.recName')"
                        :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }"
                        size="mini"
                        style="width: 400px">
            <el-input v-model.trim="listQuery1.name" :placeholder="$t('')" clearable/>
          </el-form-item>
          <!--        联系电话-->
          <el-form-item :label="$t('sysCompany.phone')"
                        :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }"
                        size="mini"
                        style="width: 400px">
            <el-input v-model.trim="listQuery1.mobile" :placeholder="$t('')" clearable/>
          </el-form-item>
          <!--        邮编-->
          <el-form-item v-if="listQuery1.recType === '6' " :label="$t('poscore.zip')"
                        :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }"
                        size="mini"
                        style="width: 400px">
            <el-input v-model.trim="listQuery1.zipCode" :placeholder="$t('')" clearable/>
          </el-form-item>
          <!--        收货地址-->
          <el-form-item :label="$t('ssCustomer.saddress')">
            <el-radio v-model="listQuery1.recType" label="4">
              {{ this.$t('pick.up.from.franchise') }}:{{ listQuery.agentNo }} - {{ listQuery.name }}
            </el-radio>
            <br>
            <el-radio v-model="listQuery1.recType" label="5">{{ this.$t('pick.up.from.branch.office') }}</el-radio>
            <br>
            <el-radio v-model="listQuery1.recType" label="6">{{ this.$t('send.by.post') }}：
              <!--            国-->
              <el-select v-model="listQuery1.country" :placeholder="$t('please.select.country.or.region')" clearable
                         size="mini"
                         style="width: 160px" @change="getProvince">
                <el-option value=""/>
                <el-option v-for="role in country" :key="role.regionCode" :label="(role.regionName)"
                           :value="role.regionCode"/>
              </el-select>
              <!--            省-->
              <el-select v-model="listQuery1.province" v-loading="sltloading"
                         :placeholder="$t('please.select.province')" clearable size="mini"
                         style="width: 160px" @change="getcity">
                <el-option value=""/>
                <el-option v-for="role in province" :key="role.regionCode" :label="(role.regionName)"
                           :value="role.regionCode"/>
              </el-select>
              <!--            市-->
              <el-select v-model="listQuery1.city" v-loading="sltloading" :placeholder="$t('please.select.city')"
                         clearable size="mini"
                         style="width: 160px" @change="getdistrict">
                <el-option value=""/>
                <el-option v-for="role in city" :key="role.regionCode" :label="(role.regionName)"
                           :value="role.regionCode"/>
              </el-select>
              <!--            县-->
              <el-select v-model="listQuery1.district" v-loading="sltloading"
                         :placeholder="$t('please.select.district.or.county')" clearable size="mini"
                         style="width: 160px">
                <el-option value=""/>
                <el-option v-for="role in district" :key="role.regionCode" :label="(role.regionName)"
                           :value="role.regionCode"/>
              </el-select>
            </el-radio>
            <br>
            <!--          详细地址-->
            <el-form-item :label="$t('miAgent.storeAddr')" size="mini" style="width: 400px">
              <el-input v-model.trim="listQuery1.storeAddr" :placeholder="$t('')" clearable/>
            </el-form-item>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px">
          <!--      上一步-->
          <el-button :loading="btnloading" icon="el-icon-back" size="mini" type="success" @click="buttonprevious">
            {{ $t('button.previous') }}
          </el-button>
          <!--      下一步-->
          <el-button :loading="btnloading" icon="el-icon-right" size="mini" type="success" @click="buttonnext1">
            {{ $t('button.next') }}
          </el-button>
          <!--      取消-->
          <el-button :loading="btnloading" icon="el-icon-close" size="mini" type="danger" @click="buttoncancel1">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </div>
      <div v-if="activeIndex === 2">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <el-form label-width="130px">
          <!--       经销商编号-->
          <el-form-item :label="$t('miMember.memberNo')">
            {{ listQuery2.memberNo }}
          </el-form-item>
          <!--        备注-->
          <el-form-item :label="$t('Common.remark')">
            <el-input v-model="listQuery2.remark" :autosize="{ minRows: 4, maxRows: 6}" style="width: 400px"
                      type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
        <p style="color:#538E0D; font-size:14px; font-weight:bold;">{{ $t('busi.finance.amount') }} <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalfA }}</span> FV <span
            style="color:#F00; font-size:14px; font-weight:bold;">{{ totalFv }}</span></p>
        <el-table
            :key="tableKey"
            v-loading="listLoading"
            :data="list"
            border
            fit
            height="500"
            highlight-current-row
            size="mini"
            style="width: 100%;"
        >
          <!--     预览 -->
          <!--<el-table-column :label="$t('button.preview')" prop="photoName" align="center" />-->
          <!--     商品编码(旧) -->
          <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
          <!--      商品编码-->
          <el-table-column :label="$t('BiGoods.goodsCode')" align="center" prop="goodscode"/>
          <!--      商品名称-->
          <el-table-column :label="$t('BiGoods.name')" align="center" prop="name"/>
          <!--      价格-->
          <el-table-column :label="$t('pd.price')" align="center" prop="standardPrice"/>
          <!--      积分-->
          <el-table-column :label="$t('busi.direct.sale_points')" align="center" prop="standardPv"/>
          <!--      可用库存量-->
          <el-table-column :label="$t('stStock.validQty')" align="center" prop="validQty"/>
          <!--      购买数量-->
          <el-table-column :label="$t('Common.buyNumber')" align="center" prop="buyQty">
            <template v-slot="{row}">
              <el-input v-model.number="row.buyQty"/>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--      上一步-->
          <el-button :loading="btnloading" icon="el-icon-back" size="mini" type="success" @click="buttonprevious2">
            {{ $t('button.previous') }}
          </el-button>
          <!--      下一步-->
          <el-button :loading="btnloading" icon="el-icon-right" size="mini" type="success" @click="buttonnext2">
            {{ $t('button.next') }}
          </el-button>
          <!--      取消-->
          <el-button :loading="btnloading" icon="el-icon-close" size="mini" type="danger" @click="buttoncancel2">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </div>
      <div v-if="activeIndex === 3">
        <el-form label-width="150px">
          <!--          商品列表-->
          <h3 style="color: #b3640d">{{ $t('mall.ProductsList') }}</h3>
          <table>
            <thead>
            <tr>
              <th>{{ $t('Old_goodsCode') }}</th>
              <th>{{ $t('BiGoods.goodsCode') }}</th>
              <th>{{ $t('BiGoods.name') }}</th>
              <th>{{ $t('pd.price') }}</th>
              <th>{{ $t('busi.direct.sale_points') }}</th>
              <th>{{ $t('Common.buyNumber') }}</th>
              <th>{{ $t('order.price.total') }}</th>
              <th>{{ $t('order.pv.total') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="i in list3" :key="i.id">
              <td>{{ i.oldcode }}</td>
              <td>{{ i.goodscode }}</td>
              <td>{{ i.name }}</td>
              <td>{{ i.standardPrice }}</td>
              <td>{{ i.standardPv }}</td>
              <td>{{ i.buyQty }}</td>
              <td>{{ highPrecisionMulL(i.standardPrice, i.buyQty) }}</td>
              <td>{{ highPrecisionMulL(i.standardPv, i.buyQty) }}</td>
            </tr>
            <tr>
              <td style="color: #b3640d">{{ $t('bdSendEfuboBonusDetail.amtCount') }}</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{{ buyQty }}</td>
              <td style="font-weight: 600">{{ totalfA }}</td>
              <td style="font-weight: 600">{{ totalFv }}</td>
            </tr>
            </tbody>
          </table>
          <!--          支付信息-->
          <h3 style="color: #b3640d">{{ $t('title.payment.info') }}</h3>
          <table v-if="fenDanShow">
            <tr>
              <!--经销商编号-->
              <td>{{ $t('miMember.memberNo') }}</td>
              <!--金额-->
              <td>{{ $t('Account.money') }}: {{ totalfA }}</td>
              <td>PV: {{ totalFv }}</td>
              <!--操作-->
              <td>{{ $t('sysOperationLog.moduleName') }}</td>
            </tr>
            <tr v-for="(ele, index) in fenDanData" :key="ele.idz">
              <td>
                <div style="display: flex;text-align: center;justify-content: center">
                  <span v-if="index===0" style="line-height: 42px">{{ ele.memberNo }}</span>
                  <el-input v-else v-model.trim="ele.memberNo" :placeholder="$t('miMember.memberNo')"
                            @blur="checkMemberNo(ele)"/>
                  <i v-show="ele.memberNoCheck===2&&index!==0" class="el-icon-circle-check"
                     style="line-height: 42px;color: #55a532"></i>
                  <i v-show="ele.memberNoCheck===1" class="el-icon-circle-close"
                     style="line-height: 42px;color: red"></i>
                </div>
              </td>
              <td>
                <span v-if="index===0">{{ ele.standardPrice }}</span>
                <el-input v-else v-model.trim="ele.standardPrice" :placeholder="$t('Account.money')"
                          @blur="checkStandardPrice(ele)"/>
              </td>
              <td>
                {{ ele.standardPv }}
              </td>
              <td>
                <el-button v-show="index>0" circle icon="el-icon-minus" type="danger"
                           @click="fenDanRemove(index)"/>
                <el-button v-show="index===fenDanData.length-1" circle icon="el-icon-plus" type="primary"
                           @click="fenDanAdd"/>
              </td>
            </tr>
          </table>
          <!--          付款金额-->
          <el-form-item v-if="fenDanShow&&listQuery3.fiPayMoney" :label="$t('fi.pay.money')">
            {{ listQuery3.fiPayMoney }}
          </el-form-item>
          <div v-if="!fenDanShow">
            <!--         商品总金额 -->
            <el-form-item :label="$t('poAssistMemberOrder.productAmount')">
              {{ listQuery3.totalAmount }}
            </el-form-item>
            <!--       物流费   -->
            <el-form-item :label="$t('busi.JPorder.yf')">
              {{ 0 }}
            </el-form-item>
            <!--          合计-->
            <el-form-item :label="$t('bdSendEfuboBonusDetail.amtCount')">
              {{ listQuery3.totalLocIn }}
            </el-form-item>
            <!--          付款金额-->
            <el-form-item v-show="companyCode==='BD'&&listQuery3.fiPayMoney" :label="$t('fi.pay.money')">
              {{ listQuery3.fiPayMoney }}
            </el-form-item>
          </div>
          <!--         支付密码 -->
          <el-form-item :label="$t('please.input.your.pay.password')"
                        :rules="{ required: true, message: this.$t('po.setInfo'), trigger: ['blur', 'change'] }"
                        size="mini"
                        style="width: 400px">
            <el-input v-model.trim="listQuery3.payPassword" :placeholder="$t('')" clearable show-password/>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <!--        上一步-->
          <el-button :loading="btnloading" icon="el-icon-back" size="mini" type="success" @click="buttonprevious3">
            {{ $t('button.previous') }}
          </el-button>
          <!--        提交-->
          <el-button :loading="btnloading" icon="el-icon-check" size="mini" type="success" @click="titlesubmit">
            {{ $t('title.submit') }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getAlRegionsByCode, getLevel1AlRegions, miMemberInfo} from "@/api/member";
import {discountedPrice, goodsListSJByMember, saveSJ, verificationSJ} from "@/api/ay-business-manager/upgradeorder";

export default {
  name: "UpgradeOrder",
  data() {
    return {
      fenDanShow: false,
      fenDanData: [
        {
          idz: 1,
          memberNo: '',
          memberNoCheck: 2,
          standardPrice: null,
          standardPv: null,
        },
      ],
      memberNoDisabled: true,
      account_name_show: false,
      oneNextIf: false,
      activeIndex: 0,
      memberNo: null,
      listQuery: {
        accountName: null
      },
      listQuerydata: {},
      listQuery1: {
        recType: '6',
        zipCode: null,
        storeAddr: null,
        name: null,
        mobile: null
      },
      listQuery2: {},
      listQuery3: {
        fiPayMoney: null
      },
      list3: [],
      tableKey: 0,
      listLoading: false,
      list: [],
      btnloading: false,
      open: false,
      //  地区
      sltloading: false,
      country: null,
      province: null,
      city: null,
      district: null
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
    totalfA() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        // return cur.standardPrice * cur.buyQty + acc
        return this.highPrecisionAdd(this.highPrecisionMul(cur.standardPrice, cur?.buyQty || 0), acc)
      }, 0)
    },
    totalFv() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        // return cur.standardPv * cur.buyQty + acc
        return this.highPrecisionAdd(this.highPrecisionMul(cur.standardPv, cur?.buyQty || 0), acc)
      }, 0)
    },
    buyQty() {
      if (!this.list || !this.list.length) {
        return 0
      }
      return this.list.reduce((acc, cur) => {
        // return cur.buyQty + acc
        return this.highPrecisionAdd(cur?.buyQty || 0, acc)
      }, 0)
    }
  },
  created() {
    this.getAgentno()
    this.getCountry()
  },
  methods: {
    highPrecisionMulL(num1, num2) {
      return this.highPrecisionMul(num1, num2)
    },
    setAmount(ele) {
      if (this.fenDanData.filter(item => item.standardPrice === null).length < 1) {
        let sum = 0
        let sum2 = 0
        this.fenDanData.map((item, index) => {
          if (index > 0) {
            sum = this.highPrecisionAdd(sum, item.standardPrice)
            sum2 = this.highPrecisionAdd(sum2, item.standardPv)
          }
        })
        const resNum = this.highPrecisionReduce(this.totalfA, sum)
        const resNum2 = this.highPrecisionReduce(this.totalFv, sum2)
        if (resNum < 5) {
          this.$message.error(this.$t('Principal_point.amount') + '5') // 主点金额必须大于等于
          ele.standardPrice = null
          ele.standardPv = null
          return
        }
        this.fenDanData[0].standardPrice = resNum
        this.fenDanData[0].standardPv = resNum2
      }
    },
    checkStandardPrice(ele) {
      if (!ele.standardPrice || isNaN(Number(ele.standardPrice)) || ele.standardPrice < 5) {
        this.$message.error(this.$t('Enter_Corresponding.amount') + '5') // 请输入对应的金额,必须为数字,且大于等于
        ele.standardPrice = null
        return
      }
      ele.standardPrice = Math.floor(Number(ele.standardPrice) * 100) / 100
      ele.standardPv = this.highPrecisionDiv(this.highPrecisionMul(ele.standardPrice, this.totalFv), this.totalfA, 'floor', 2)
      if (!Number(ele.standardPv)) {
        this.$message.error(this.$t('pd.pv.must.integer').toString()) // PV必须为正整数
        ele.standardPrice = null
        ele.standardPv = null
        return
      }
      this.setAmount(ele)
    },
    checkMemberNo(ele) {
      if (ele.memberNo) {
        if (this.fenDanData.filter(item => item.memberNo === ele.memberNo).length > 1) {
          this.$message.error(this.$t('exist.no.yes').toString()) // 编号已存在
          ele.memberNoCheck = 1
          return
        }
        miMemberInfo({'memberNo': ele.memberNo}).then((res) => {
          if (res.data.companyCode === 'BD') {
            ele.memberNoCheck = 2
          } else {
            ele.memberNoCheck = 1
            this.$message.error(this.$t('No_BD_member').toString()) // 非孟加拉经销商
          }
        }).catch(err => {
          ele.memberNoCheck = 1
          console.error(err)
        })
      } else {
        ele.memberNoCheck = 0
      }
    },
    fenDanRemove(index) {
      this.fenDanData.splice(index, 1)
      this.setAmount()
    },
    fenDanAdd() {
      // if (this.fenDanData.length === 22) {
      //   this.$message.error(this.$t('Split_limitation')) // 最多分21个
      //   return
      // }
      this.fenDanData.push({
        idz: this.fenDanData[this.fenDanData.length - 1].idz + 1,
        memberNo: null,
        memberNoCheck: 0,
        standardPrice: null,
        standardPv: null,
      })
    },
    //国
    getCountry() {
      getLevel1AlRegions().then(res => {
        this.country = res.data
      }).catch(err => {
        console.error(err)
      })
    },
    //省
    getProvince() {
      if (!this.listQuery1.country) {
        this.listQuery1.province = null
        this.listQuery1.city = null
        this.listQuery1.district = null
      } else {
        this.sltloading = true
        getAlRegionsByCode({'regionCode': this.listQuery1.country}).then(res => {
          this.listQuery1.province = null
          this.listQuery1.city = null
          this.listQuery1.district = null
          this.province = res.data
          this.sltloading = false
        }).catch(err => {
          this.sltloading = false
          console.error(err)
        })
      }
    },
    //市
    getcity() {
      this.sltloading = true
      getAlRegionsByCode({'regionCode': this.listQuery1.province}).then(res => {
        this.listQuery1.city = null
        this.listQuery1.district = null
        this.city = res.data
        this.sltloading = false
      }).catch(err => {
        this.sltloading = false
        console.error(err)
      })
    },
    //区
    getdistrict() {
      this.sltloading = true
      getAlRegionsByCode({'regionCode': this.listQuery1.city}).then(res => {
        this.district = res.data
        this.sltloading = false
      }).catch(err => {
        this.sltloading = false
        console.error(err)
      })
    },
    getAgentno() {
      if (this.isAgent) {
        this.memberNoDisabled = false
        // this.memberNo = ''
        if (this.memberNo) {
          miMemberInfo({'memberNo': this.memberNo}).then(res => {
            this.listQuerydata = res.data
            this.listQuery.accountName = res.data.name
            this.listQuery.agentNo = res.data.agentNo
            this.listQuery.name = res.data.agentName
            this.listQuery2.name = res.data.name
            this.btnloading = false
            this.open = true
            this.oneNextIf = false
            this.account_name_show = false
          }).catch(err => {
            this.listQuery.accountName = ''
            this.account_name_show = true
            this.oneNextIf = true
            this.btnloading = false
            console.error(err)
          })
        } else {
          this.oneNextIf = true
          this.listQuery.accountName = ''
          this.account_name_show = false
        }
      } else {
        this.memberNoDisabled = true
        this.memberNo = this.userCode
        miMemberInfo({'memberNo': this.memberNo}).then(res => {
          this.listQuerydata = res.data
          this.listQuery.accountName = res.data.name
          this.listQuery.agentNo = res.data.agentNo
          this.listQuery.name = res.data.agentName
          this.listQuery2.name = res.data.name
          this.btnloading = false
          this.open = true
          this.oneNextIf = false
        }).catch(() => {
          this.btnloading = false
        })
      }
    },
    buttonnext() {
      this.btnloading = true
      if (!this.memberNo) {
        return this.$message.error(this.$t('po.setInfo'), this.$t('miMember.memberNo'))
      } else {
        verificationSJ({'memberNo': this.memberNo}).then(() => {
          this.btnloading = false
          if (this.open === true) {
            if (this.companyCode === 'BD') {
              this.listQuery2.memberNo = this.memberNo
              goodsListSJByMember({'memberNo': this.memberNo}).then(res => {
                this.list = res.data
                this.listQuery1.recType = '1'
                this.btnloading = false
                this.activeIndex = 2
              }).catch(err => {
                console.error(err)
              })
            } else if (this.companyCode === 'IN' && this.isAgent) {
              this.listQuery2.memberNo = this.memberNo
              goodsListSJByMember({'memberNo': this.memberNo}).then(res => {
                this.list = res.data
                this.listQuery1.recType = '1'
                this.btnloading = false
                this.activeIndex = 2
              }).catch(err => {
                console.error(err)
              })
            } else {
              this.activeIndex = 1
              this.listQuery1.name = this.listQuerydata.name
              this.listQuery1.mobile = this.listQuerydata.mobile
              this.listQuery1.storeAddr = this.listQuerydata.storeAddr
              this.listQuery1.zipCode = null
            }
          }
        }).catch(err => {
          this.btnloading = false
          console.error(err)
        })
      }
    },
    buttoncancel() {
      this.$router.push({name: 'OrderQuery'})
    },
    buttonprevious() {
      this.activeIndex = 0
    },
    buttonnext1() {
      if (this.listQuery1.recType === '6' && this.listQuery1.zipCode === null) {
        return this.$message.error(this.$t('item.in.bold.required'))
      } else {
        this.listQuery2.memberNo = this.memberNo
        this.btnloading = true
        goodsListSJByMember({'memberNo': this.memberNo}).then(res => {
          this.list = res.data
          this.btnloading = false
          this.activeIndex = 2
        }).catch(err => {
          console.error(err)
        })
      }
    },
    buttoncancel1() {
      this.$router.push({name: 'OrderQuery'})
    },
    buttonprevious2() {
      if (this.companyCode === 'BD') {
        this.activeIndex = 0
      } else if (this.companyCode === 'IN' && this.isAgent) {
        this.activeIndex = 0
      } else {
        this.activeIndex = 1
      }
    },
    async buttonnext2() {
      if (this.buyQty <= 0) {
        return this.$message.error(this.$t('leastInputANumber'))
      }
      this.list3 = []

      for (let a = 0; a < this.list.length; a++) {
        if (this.list[a].buyQty > 0) {
          this.list3.push(this.list[a])
        }
      }

      // let includeM003 = this.list3.some((item) => item.goodscode === '(BD)M003')
      // let includeM005 = this.list3.some((item) => item.goodscode === '(BD)M005')
      //
      // if (includeM003 && includeM005 && this.list3.length > 2) {
      //   // 仅能选择(BD)M003和(BD)M005
      //   return this.$message.error(this.$t('BDM003OR5Tip1').toString())
      // }
      //
      // if (((includeM003 && !includeM005) || (!includeM003 && includeM005)) && this.list3.length > 1) {
      //   // 仅能选择(BD)M003或(BD)M005
      //   return this.$message.error(this.$t('BDM003OR5Tip2').toString())
      // }
      //
      // this.fenDanShow = (includeM003 || includeM005) && this.companyCode === 'BD'

      let includeD005 = this.list3.some((item) => item.goodscode === 'CN-D020-01-00')
      let includeCX041 = this.list3.some((item) => item.goodscode === '(BD)CX04-1')
      let includeCX042 = this.list3.some((item) => item.goodscode === '(BD)CX04-2')

      this.fenDanShow = !includeCX041 && !includeCX042 && !includeD005 && this.companyCode === 'BD' && this.totalfA >= 10

      this.listQuery3.totalLocIn = this.totalfA
      this.listQuery3.totalAmount = this.totalfA
      this.fenDanData = [{
        idz: 1,
        memberNo: '',
        memberNoCheck: 2,
        standardPrice: null,
        standardPv: null,
      },]
      this.fenDanData[0].memberNo = this.listQuery2.memberNo
      this.fenDanData[0].standardPrice = this.totalfA
      this.fenDanData[0].standardPv = this.totalFv
      if (this.companyCode === 'BD') {
        this.listQuery3.fiPayMoney = null
        try {
          this.listQuery3.fiPayMoney = await this.getPayMoney(this.listQuery2.memberNo, this.totalfA, this.totalFv)
        } catch (e) {
          console.log(e)
          this.listQuery3.fiPayMoney = null
        }
      }
      this.activeIndex = 3
    },
    buttoncancel2() {
      this.$.push({name: 'OrderQuery'})
    },
    buttonprevious3() {
      this.list3 = []
      this.activeIndex = 2
    },
    titlesubmit() {
      if (!this.listQuery3.payPassword) {
        this.$message.error(this.$t('please.input.your.pay.password'))
        return
      }
      if (this.companyCode === 'BD') { // 孟加拉分单赋值
        for (let i = 0; i < this.fenDanData.length; i++) {
          if (!this.fenDanData[i].memberNo) {
            this.$message.error(this.$t('required.input.memberNo')) // 请填写经销商编号
            return
          }
          if (this.fenDanData[i].memberNoCheck < 2) {
            this.$message.error(this.$t('please.requied.input.memberNo')) // 请输入正确的经销商编号
            return
          }
          if (!Number(this.fenDanData[i].standardPrice)) {
            this.$message.error(this.$t('fiPayAdvice.money.required')) // 请输入对应的金额,必须为数字,且大于0
            return
          }
          if (!Number(this.fenDanData[i].standardPv)) {
            this.$message.error(this.$t('pd.pv.must.integer')) // PV必须为正整数
            return
          }
        }
        this.listQuery3.poOrderSubList = this.fenDanData
      }
      this.listQuery3.name = this.listQuery1.name
      this.listQuery3.mobile = this.listQuery1.mobile
      this.listQuery3.zipCode = this.listQuery1.zipCode
      this.listQuery3.recType = this.listQuery1.recType
      this.listQuery3.country = this.listQuery1.country
      this.listQuery3.province = this.listQuery1.province
      this.listQuery3.city = this.listQuery1.city
      this.listQuery3.district = this.listQuery1.district
      this.listQuery3.memberNo = this.listQuery2.memberNo
      this.listQuery3.remark = this.listQuery2.remark
      this.listQuery3.goodsList = this.list3
      this.btnloading = true
      saveSJ({...this.listQuery3}).then(() => {
        this.$router.push({name: 'OrderQuery', params: {sgopen: this.sgopen}})
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.btnloading = false
      }).catch(err => {
        this.btnloading = false
        console.error(err)
        this.$message.error(this.$t('bdSendRegister.operaterFail'))
      })
    },
    getPayMoney(userCode, standardPrice, standardPv) {
      return new Promise((resolve, reject) => {
        discountedPrice({userCode, standardPrice, standardPv}).then((res) => {
          resolve(res.data)
        }).catch(err => {
          console.error(err)
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  margin: 20px 0 20px 0px;
  width: 100%;
  border: 1px solid #eee;
  border-collapse: collapse;
  text-align: center;

  tr {
    th {
      width: 150px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid #eee;
    }

    td {
      width: 200px;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      border: 1px solid #eee;
    }
  }

  thead {
    th {
      font-size: 18px;
      border-right: 1px solid #eee;
      width: 400px;
    }
  }

  tbody {
    td {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid #eee;
      width: 200px;
    }
  }
}

.account_name_css:after {
  content: 'X';
  color: #ff4949;
}

.disabled_remove_css {
  ::v-deep .el-input__inner {
    //background-color: white;
    color: black;
  }
}
</style>
